import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadQueryParameters } from './app-meta.actions';
import { tap } from 'rxjs';
import { ConfigApiService } from 'src/app/services/config-api.service';
import { InstructionService } from 'src/app/services/instruction.service';

@Injectable()
export class AppMetaEffects {
  constructor(
    private actions$: Actions,
    private configApiService: ConfigApiService,
    private instuctionService: InstructionService
  ) {}

  saveParams = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadQueryParameters),
        tap(params => {
          // This is another reformation of these value.
          // TODO: Check why the code in subscription.service is doing this
          const reformedParams = {
            user: params.user.value,
            id: params.id.value,
            project: params.project.value,
            key: params.key.value,
            lng: params.lng.value,
            country: params.country.value,
            RID: params.RID.value
          };
          this.configApiService.setParams(reformedParams);
          this.instuctionService.getLanguageIdentifier(params.lng.value, params.country.value);
        })
      ),
    { dispatch: false }
  );
}
